'use strict'

module.exports = {
  copySync: require('./copy-sync')
}



//////////////////
// WEBPACK FOOTER
// ./~/ethpm/~/fs-extra/lib/copy-sync/index.js
// module id = 1280
// module chunks = 0 1